import { render } from "./collection-policy-config-list.vue?vue&type=template&id=3f5e023c&scoped=true"
import script from "./collection-policy-config-list.vue?vue&type=script&lang=js"
export * from "./collection-policy-config-list.vue?vue&type=script&lang=js"

import "./collection-policy-config-list.vue?vue&type=style&index=0&id=3f5e023c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5e023c"]])

export default __exports__